import "@story/story_assets/dom_extend";
import { onDocumentReady } from "@story/story_assets";
import { Carousel } from "@story/story_assets/carousel";

import "@story/story_assets/slide";
import "@story/story_assets/recaptcha";
import "@story/story_assets/ajax_form";
import "@story/story_assets/modal/modal_gallery";

//= require story_assets/utils
//= require story_assets/dom_extend
//= require story_assets/ajax

//= require story_assets/media_breakpoint
//= require story_assets/animations
//= require story_assets/slide

//= require story_assets/module_loader
//= require story_assets/modules/base
//= require story_assets/modules/google_recaptcha

//= require story_assets/ajax_form
//= require story_assets/recaptcha
//= require story_assets/carousel
//= require story_assets/slider

//= require story_assets/modal/modal
//= require story_assets/modal/modal_dialog
//= require story_assets/modal/modal_gallery

//= require components/assets
//= require components/smap_loader

; (function() {

	document.addEventSelectorListener("click", "[data-roll]", function(event, target) {
		event.preventDefault();
		let element = document.querySelector(target.getAttribute("data-roll"));
		element.classList.toggle("expanded");
	});

	onDocumentReady(function() {
		for (let carousel of document.querySelectorAll(".carousel")) {
			new Carousel(carousel);
		}
	});

}());